module.exports = __webpack_public_path__ + "static/media/400039_02.2d162062.png";